import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import useSeo, { CANONICAL_BASE } from "@/lib/useSeo";

export default function ContentPage({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const [page, setPage] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setNf(false); api.get(`/content/${slug}`).then(({ data }) => setPage(data)).catch(() => setNf(true)); }, [slug]);
  useSeo(page ? { title: `${page.title} — ONUSA`, description: page.body?.slice(0, 150), canonical: CANONICAL_BASE + "/" + slug } : {});
  if (nf) return <div className="onusa-container py-32 text-center"><p className="heading-x text-2xl">PAGINA NIET GEVONDEN</p></div>;
  if (!page) return <div className="onusa-container py-32"><div className="h-8 bg-[#E8E1D8] animate-pulse w-1/3" /></div>;
  return (
    <div className="onusa-container py-16 md:py-24 max-w-3xl" data-testid={`content-page-${slug}`}>
      <p className="label-x">ONUSA</p>
      <h1 className="heading-x text-3xl md:text-5xl mt-2 mb-8">{page.title}</h1>
      <div className="prose text-[#1D1D1B]/85 leading-relaxed whitespace-pre-wrap">{page.body}</div>
      {slug === "contact" && (
        <div className="mt-10 rule-x pt-8 space-y-2">
          <p className="label-x">EMAIL</p>
          <a href="mailto:info@onusa.nl" className="text-lg">info@onusa.nl</a>
        </div>
      )}
    </div>
  );
}
